///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, salesByArticleHistoryManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getSalesByArticleHistory = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_SALES_BY_ARTICLE_HISTORY(user['idUser'], payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(salesByArticleHistoryManagerActionCreators.getSalesByArticleHistorySuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesByArticleHistoryManagerActionCreators.getSalesByArticleHistoryFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY, getSalesByArticleHistory)
}

export default sagas
